import React, { useState } from 'react';
import { ZdsAdvancedSelect, ZdsIcon, ZdsSelect, ZdsAdvancedSelectItem } from '@zig-design-system/ui-components-react';
import { renderToString } from 'react-dom/server';
import Translation from '../../../../Shared/components/Translation';
const rangeOptions = [
    { label: '', value: '' },
    { label: '1km', value: '1km' },
    { label: '2km', value: '2km' },
    { label: '5km', value: '5km' },
    { label: '10km', value: '10km' },
    { label: '15km', value: '15km' },
    { label: '30km', value: '30km' },
    { label: '50km', value: '50km' },
];
const getSelectedOptions = (options, activeFilters) => {
    var _a, _b, _c;
    const selectedOptions = [];
    if ((_a = activeFilters.userFilters) === null || _a === void 0 ? void 0 : _a.city) {
        const cities = Array.isArray(activeFilters.userFilters.city)
            ? activeFilters.userFilters.city
            : [activeFilters.userFilters.city];
        cities.forEach((city) => {
            const cityOption = options.find((option) => option.filterQuery === 'city' && option.filterValue === city);
            if (cityOption) {
                selectedOptions.push(cityOption);
            }
        });
    }
    if ((_b = activeFilters.userFilters) === null || _b === void 0 ? void 0 : _b.quarter) {
        const quarters = Array.isArray(activeFilters.userFilters.quarter)
            ? activeFilters.userFilters.quarter
            : [activeFilters.userFilters.quarter];
        quarters.forEach((city) => {
            const quarterOption = options.find((option) => option.filterQuery === 'quarter' && option.filterValue === city);
            if (quarterOption) {
                selectedOptions.push(quarterOption);
            }
        });
    }
    if ((_c = activeFilters.userFilters) === null || _c === void 0 ? void 0 : _c.location) {
        const locationOption = options.find((option) => {
            return (option.additionalData.location.lng === activeFilters.userFilters.location.point.lng &&
                option.additionalData.location.lat === activeFilters.userFilters.location.point.lat);
        });
        if (locationOption) {
            selectedOptions.push(locationOption);
        }
    }
    return selectedOptions;
};
const LocationFilter = ({ filter, handleFilterChange, activeFilters }) => {
    var _a, _b, _c, _d;
    const [searchText, setSearchText] = useState('');
    const selectedOptions = getSelectedOptions(filter.options, activeFilters);
    const showRangeFilter = selectedOptions.length < 2 &&
        (selectedOptions.length === 0 ||
            (selectedOptions[0].additionalData.location.lng && selectedOptions[0].additionalData.location.lat));
    const items = [];
    filter.options.forEach((option) => {
        if (!searchText || option.label.toLowerCase().startsWith(searchText)) {
            const item = {
                id: option.id,
                title: option.label,
                subtitle: option.additionalData.secondaryText,
                selected: selectedOptions.some((selectedOption) => option.id === selectedOption.id),
            };
            items.push(item);
        }
    });
    return (React.createElement("div", { id: filter.field, className: "zds-grid zds-gap-4" },
        React.createElement(ZdsAdvancedSelect, { label: renderToString(React.createElement(Translation, { item: filter.label, asString: true })), clearable: true, searchable: true, multiple: true, fullWidth: true, "text-type": "multiline", "show-selected": true, onZdsInputChange: (e) => {
                setSearchText(e.detail.toLowerCase());
            }, onZdsChange: handleFilterChange }, items.map((item) => (
        // item.selected || undefined because of a bug in ZDS.
        React.createElement(ZdsAdvancedSelectItem, { "item-id": item.id, key: item.id, selected: item.selected || undefined },
            React.createElement(ZdsIcon, { library: "fa-solid", name: "location-dot", size: "md", slot: "icon" }),
            React.createElement("span", { slot: "primary-text" }, item.title),
            React.createElement("span", { slot: "secondary-text" }, item.subtitle))))),
        showRangeFilter && (React.createElement(ZdsSelect, { onZdsInput: handleFilterChange, label: "Straal", value: (_b = (_a = activeFilters.userFilters) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.distance, disabled: ((_c = activeFilters.userFilters) === null || _c === void 0 ? void 0 : _c.city) === undefined &&
                ((_d = activeFilters.userFilters) === null || _d === void 0 ? void 0 : _d.location) === undefined
                ? true
                : undefined }, rangeOptions.map((rangeOption, index) => (React.createElement("option", { value: rangeOption.value, key: index }, rangeOption.label)))))));
};
export default LocationFilter;
